(function () {
  if (window.matchMedia('(min-width: 750px)').matches) return;

  const bar = document.querySelector('[data-nutrio-sticky-atc]');
  const buyBox = document.querySelector('[data-nutrio-buy-box]');
  const form = document.querySelector('product-info .product-form');
  if (!bar || !buyBox || !form) return;

  const submitBtn = form.querySelector('[type="submit"]');
  const barBtn = bar.querySelector('[data-nutrio-sticky-submit]');
  if (!barBtn || !submitBtn) return;

  barBtn.addEventListener('click', function () {
    if (!submitBtn.disabled) submitBtn.click();
  });

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        const visible = !entry.isIntersecting && !submitBtn.disabled;
        bar.classList.toggle('is-visible', visible);
        bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      });
    },
    { rootMargin: '0px', threshold: 0 }
  );

  observer.observe(buyBox);

  const mo = new MutationObserver(function () {
    if (submitBtn.disabled) bar.classList.remove('is-visible');
  });
  mo.observe(submitBtn, { attributes: true, attributeFilter: ['disabled'] });
})();
